import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { Tabs, Tab } from 'components/common/tabs/tabs';
import Inputs from 'components/inputs/inputs';

const styles = {
  numberInput: {
    display: 'inline',
    width: '70px',
    textAlign: 'center'
  }
};

export const Frequency = {
  undefined: 0,
  hourly: 1,
  daily: 2,
  weekly: 3,
  monthlyByDay: 4,
  monthlyByWeek: 5,
  onDemand: 6
};

export function SchedulerForm(props) {
  const { defaultValues, onChange } = props;

  const [activeTab, setActiveTab] = useState(Frequency.daily);
  const [hourlyRecurrence, setHourlyRecurrence] = useState('12');
  const [dailyRecurrence, setDailyRecurrence] = useState('1');
  const [weeklyRecurrence, setWeeklyRecurrence] = useState('1');
  const [monthlyByWeekRecurrence, setMonthlyByWeekRecurrence] = useState('first');
  const [repeatDaysByWeek, setRepeatDaysByWeek] = useState('MON');
  const [repeatMonthsByDay, setRepeatMonthsByDay] = useState('JAN');
  const [repeatMonthsByWeek, setRepeatMonthsByWeek] = useState('JAN');
  const [repeatDaysMonthlyByDay, setRepeatDaysMonthlyByDay] = useState('1');
  const [repeatDaysMonthlyByWeek, setRepeatDaysMonthlyByWeek] = useState('MON');
  const [lastChange, setLastChange] = useState({ frequencyId: Frequency.daily, recurEvery: '1' });
  const [startDateTime, setStartDateTime] = useState(defaultValues && defaultValues.startDateTime ? defaultValues.startDateTime : null);

  const variant = 'app';

  useEffect(() => {
    if (defaultValues) {
      if (defaultValues.frequencyId) {
        setActiveTab(defaultValues.frequencyId);
      }
      setHourlyRecurrence(defaultValues.frequencyId === Frequency.hourly ? defaultValues.recurEvery : hourlyRecurrence);
      setDailyRecurrence(defaultValues.frequencyId === Frequency.daily ? defaultValues.recurEvery : dailyRecurrence);
      setWeeklyRecurrence(defaultValues.frequencyId === Frequency.weekly ? defaultValues.recurEvery : weeklyRecurrence);
      setMonthlyByWeekRecurrence(defaultValues.frequencyId === Frequency.monthlyByWeek ? defaultValues.recurEvery : monthlyByWeekRecurrence);
      setRepeatDaysByWeek(defaultValues.frequencyId === Frequency.weekly && defaultValues.repeatDays ? defaultValues.repeatDays : repeatDaysByWeek);
      setRepeatMonthsByDay(defaultValues.frequencyId === Frequency.monthlyByDay && defaultValues.repeatMonths ? defaultValues.repeatMonths : repeatMonthsByDay);
      setRepeatMonthsByWeek(defaultValues.frequencyId === Frequency.monthlyByWeek && defaultValues.repeatMonths ? defaultValues.repeatMonths : repeatMonthsByWeek);
      setRepeatDaysMonthlyByDay(defaultValues.frequencyId === Frequency.monthlyByDay && defaultValues.repeatDays ? defaultValues.repeatDays : repeatDaysMonthlyByDay);
      setRepeatDaysMonthlyByWeek(defaultValues.frequencyId === Frequency.monthlyByWeek && defaultValues.repeatDays ? defaultValues.repeatDays : repeatDaysMonthlyByWeek);
      setStartDateTime(defaultValues.startDateTime ? defaultValues.startDateTime : startDateTime);
      setLastChange(defaultValues);
    }
  }, [defaultValues]);

  const setWeekDaysForWeekly = (dayString, isChecked) => {
    let newArr = repeatDaysByWeek.split(',').filter((item) => item !== '');
    if (isChecked) {
      newArr.push(dayString);
    }
    else {
      newArr = newArr.filter((item) => item !== dayString);
    }
    const newRepeatDays = newArr.join(',');
    setRepeatDaysByWeek(newRepeatDays);
    dispatchChange({ repeatDays: newRepeatDays });
  };

  const setWeekDaysForMonthlyByWeek = (dayString, isChecked) => {
    let newArr = repeatDaysMonthlyByWeek.split(',').filter((item) => item !== '');
    if (isChecked) {
      newArr.push(dayString);
    }
    else {
      newArr = newArr.filter((item) => item !== dayString);
    }
    const newRepeatDays = newArr.join(',');
    setRepeatDaysMonthlyByWeek(newRepeatDays);
    dispatchChange({ repeatDays: newRepeatDays });
  };

  const setMonthsByDay = (monthString, isChecked) => {
    let newArr = repeatMonthsByDay.split(',').filter((item) => item !== '');
    if (isChecked) {
      newArr.push(monthString);
    }
    else {
      newArr = newArr.filter((item) => item !== monthString);
    }
    const newRepeatMonthsByDay = newArr.join(',');
    setRepeatMonthsByDay(newRepeatMonthsByDay);
    dispatchChange({ repeatMonths: newRepeatMonthsByDay });
  };

  const setMonthsByWeek = (monthString, isChecked) => {
    let newArr = repeatMonthsByWeek.split(',').filter((item) => item !== '');
    if (isChecked) {
      newArr.push(monthString);
    }
    else {
      newArr = newArr.filter((item) => item !== monthString);
    }
    const newRepeatMonthsByWeek = newArr.join(',');
    setRepeatMonthsByWeek(newRepeatMonthsByWeek);
    dispatchChange({ repeatMonths: newRepeatMonthsByWeek });
  };

  const dispatchChange = (mutation) => {
    let newChange = { ...lastChange };
    if (mutation.frequencyId) {
      setActiveTab(mutation.frequencyId);
      switch (mutation.frequencyId) {
        case Frequency.hourly:
          newChange = {
            frequencyId: Frequency.hourly,
            recurEvery: hourlyRecurrence,
            startDateTime
          };
          break;
        case Frequency.daily:
          newChange = {
            frequencyId: Frequency.daily,
            recurEvery: dailyRecurrence,
            startDateTime
          };
          break;
        case Frequency.weekly:
          newChange = {
            frequencyId: Frequency.weekly,
            recurEvery: weeklyRecurrence,
            repeatDays: repeatDaysByWeek,
            startDateTime
          };
          break;
        case Frequency.monthlyByDay:
          newChange = {
            frequencyId: Frequency.monthlyByDay,
            repeatDays: repeatDaysMonthlyByDay,
            repeatMonths: repeatMonthsByDay,
            startDateTime
          };
          break;
        case Frequency.monthlyByWeek:
          newChange = {
            frequencyId: Frequency.monthlyByWeek,
            recurEvery: monthlyByWeekRecurrence,
            repeatDays: repeatDaysMonthlyByWeek,
            repeatMonths: repeatMonthsByWeek,
            startDateTime
          };
          break;
        default:
          break;
      }
    }
    if (mutation.hasOwnProperty('recurEvery')) {
      switch (activeTab) {
        case Frequency.hourly:
          newChange.recurEvery = mutation.recurEvery;
          setHourlyRecurrence(mutation.recurEvery);
          break;
        case Frequency.daily:
          newChange.recurEvery = mutation.recurEvery;
          setDailyRecurrence(mutation.recurEvery);
          break;
        case Frequency.weekly:
          newChange.recurEvery = mutation.recurEvery;
          setWeeklyRecurrence(mutation.recurEvery);
          break;
        case Frequency.monthlyByWeek:
          newChange.recurEvery = mutation.recurEvery;
          setMonthlyByWeekRecurrence(mutation.recurEvery);
          break;
        default:
          break;
      }
    }
    if (mutation.hasOwnProperty('repeatDays')) {
      newChange.repeatDays = mutation.repeatDays;
    }
    if (mutation.hasOwnProperty('startDateTime')) {
      newChange.startDateTime = mutation.startDateTime;
    }
    if (mutation.hasOwnProperty('repeatMonths')) {
      newChange.repeatMonths = mutation.repeatMonths;
    }

    setLastChange(newChange);

    if (onChange) {
      onChange(newChange);
    }
  };

  return (
    <>
      <Form.Group>
        <Form.Label required>Start Date &amp; Time</Form.Label>
        <Inputs.DateTime
          required
          placeholder='Please select start date and time'
          description='Start Date & Time'
          value={startDateTime}
          onChange={(v) => {
            setStartDateTime(v);
            dispatchChange({ startDateTime: v });
          }}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Recurrance</Form.Label>
        <Tabs variant={variant} selection={activeTab} onSelect={(key) => dispatchChange({ frequencyId: parseInt(key) })}>
          <Tab value={Frequency.hourly} title='Hourly'>
            <Form.Group className='mt-2'>
              <span className='mr-2'>Recur every</span>
              <Inputs.Integer min='1' max='23' value={hourlyRecurrence} onValueChange={(v) => dispatchChange({ recurEvery: v })} style={styles.numberInput} />
              <span className='ml-2'>hours</span>
            </Form.Group>
          </Tab>
          <Tab value={Frequency.daily} title='Daily'>
            <Form.Group className='mt-2'>
              <span className='mr-2'>Recur every</span>
              <Inputs.Integer min='1' max='30' value={dailyRecurrence} onValueChange={(v) => dispatchChange({ recurEvery: v })} style={styles.numberInput} />
              <span className='ml-2'>days</span>
            </Form.Group>
          </Tab>
          <Tab value={Frequency.weekly} title='Weekly'>
            <Form.Group className='mt-2'>
              <span className='mr-2'>Recur every</span>
              <Inputs.Integer min='1' max='52' value={weeklyRecurrence} onValueChange={(v) => dispatchChange({ recurEvery: v })} style={styles.numberInput} />
              <span className='ml-2'>weeks on:</span>
            </Form.Group>
            <Form.Group className='ml-4'>
              <Inputs.Checkbox variant={variant} label='Monday' checked={repeatDaysByWeek.indexOf('MON') !== -1} onValueChange={(v) => setWeekDaysForWeekly('MON', v)} />
              <Inputs.Checkbox variant={variant} label='Tuesday' checked={repeatDaysByWeek.indexOf('TUE') !== -1} onValueChange={(v) => setWeekDaysForWeekly('TUE', v)} />
              <Inputs.Checkbox variant={variant} label='Wednesday' checked={repeatDaysByWeek.indexOf('WED') !== -1} onValueChange={(v) => setWeekDaysForWeekly('WED', v)} />
              <Inputs.Checkbox variant={variant} label='Thursday' checked={repeatDaysByWeek.indexOf('THU') !== -1} onValueChange={(v) => setWeekDaysForWeekly('THU', v)} />
              <Inputs.Checkbox variant={variant} label='Friday' checked={repeatDaysByWeek.indexOf('FRI') !== -1} onValueChange={(v) => setWeekDaysForWeekly('FRI', v)} />
              <Inputs.Checkbox variant={variant} label='Saturday' checked={repeatDaysByWeek.indexOf('SAT') !== -1} onValueChange={(v) => setWeekDaysForWeekly('SAT', v)} />
              <Inputs.Checkbox variant={variant} label='Sunday' checked={repeatDaysByWeek.indexOf('SUN') !== -1} onValueChange={(v) => setWeekDaysForWeekly('SUN', v)} />
            </Form.Group>
          </Tab>
          <Tab value={Frequency.monthlyByDay} title='Monthly (by day)'>
            <Form.Group className='mt-2'>
              <span className='mr-2'>On the</span>
              <Inputs.Integer min='1' max='31' value={repeatDaysMonthlyByDay} onValueChange={(v) => dispatchChange({ repeatDays: v })} style={styles.numberInput} />
              <span className='ml-2'>day of:</span>
            </Form.Group>
            <Form.Group className='ml-4'>
              <Inputs.Checkbox variant={variant} label='January' checked={repeatMonthsByDay.indexOf('JAN') !== -1} onValueChange={(v) => setMonthsByDay('JAN', v)} />
              <Inputs.Checkbox variant={variant} label='February' checked={repeatMonthsByDay.indexOf('FEB') !== -1} onValueChange={(v) => setMonthsByDay('FEB', v)} />
              <Inputs.Checkbox variant={variant} label='March' checked={repeatMonthsByDay.indexOf('MAR') !== -1} onValueChange={(v) => setMonthsByDay('MAR', v)} />
              <Inputs.Checkbox variant={variant} label='April' checked={repeatMonthsByDay.indexOf('APR') !== -1} onValueChange={(v) => setMonthsByDay('APR', v)} />
              <Inputs.Checkbox variant={variant} label='May' checked={repeatMonthsByDay.indexOf('MAY') !== -1} onValueChange={(v) => setMonthsByDay('MAY', v)} />
              <Inputs.Checkbox variant={variant} label='June' checked={repeatMonthsByDay.indexOf('JUN') !== -1} onValueChange={(v) => setMonthsByDay('JUN', v)} />
              <Inputs.Checkbox variant={variant} label='July' checked={repeatMonthsByDay.indexOf('JUL') !== -1} onValueChange={(v) => setMonthsByDay('JUL', v)} />
              <Inputs.Checkbox variant={variant} label='August' checked={repeatMonthsByDay.indexOf('AUG') !== -1} onValueChange={(v) => setMonthsByDay('AUG', v)} />
              <Inputs.Checkbox variant={variant} label='September' checked={repeatMonthsByDay.indexOf('SEP') !== -1} onValueChange={(v) => setMonthsByDay('SEP', v)} />
              <Inputs.Checkbox variant={variant} label='October' checked={repeatMonthsByDay.indexOf('OCT') !== -1} onValueChange={(v) => setMonthsByDay('OCT', v)} />
              <Inputs.Checkbox variant={variant} label='November' checked={repeatMonthsByDay.indexOf('NOV') !== -1} onValueChange={(v) => setMonthsByDay('NOV', v)} />
              <Inputs.Checkbox variant={variant} label='December' checked={repeatMonthsByDay.indexOf('DEC') !== -1} onValueChange={(v) => setMonthsByDay('DEC', v)} />
            </Form.Group>
          </Tab>
          <Tab value={Frequency.monthlyByWeek} title='Monthly (by week)'>
            <Form.Group className='mt-2'>On the:</Form.Group>
            <Form.Group className='ml-4'>
              <Inputs.RadioGroup value={monthlyByWeekRecurrence} onChange={(v) => dispatchChange({ recurEvery: v })}>
                <Inputs.Radio variant={variant} label='First' value='first' checked={monthlyByWeekRecurrence === 'first'} />
                <Inputs.Radio variant={variant} label='Second' value='second' checked={monthlyByWeekRecurrence === 'second'} />
                <Inputs.Radio variant={variant} label='Third' value='third' checked={monthlyByWeekRecurrence === 'third'} />
                <Inputs.Radio variant={variant} label='Last' value='last' checked={monthlyByWeekRecurrence === 'last'} />
              </Inputs.RadioGroup>
            </Form.Group>
            <Form.Group>Week of:</Form.Group>
            <Form.Group className='ml-4'>
              <Inputs.Checkbox variant={variant} label='January' checked={repeatMonthsByWeek.indexOf('JAN') !== -1} onValueChange={(v) => setMonthsByWeek('JAN', v)} />
              <Inputs.Checkbox variant={variant} label='February' checked={repeatMonthsByWeek.indexOf('FEB') !== -1} onValueChange={(v) => setMonthsByWeek('FEB', v)} />
              <Inputs.Checkbox variant={variant} label='March' checked={repeatMonthsByWeek.indexOf('MAR') !== -1} onValueChange={(v) => setMonthsByWeek('MAR', v)} />
              <Inputs.Checkbox variant={variant} label='April' checked={repeatMonthsByWeek.indexOf('APR') !== -1} onValueChange={(v) => setMonthsByWeek('APR', v)} />
              <Inputs.Checkbox variant={variant} label='May' checked={repeatMonthsByWeek.indexOf('MAY') !== -1} onValueChange={(v) => setMonthsByWeek('MAY', v)} />
              <Inputs.Checkbox variant={variant} label='June' checked={repeatMonthsByWeek.indexOf('JUN') !== -1} onValueChange={(v) => setMonthsByWeek('JUN', v)} />
              <Inputs.Checkbox variant={variant} label='July' checked={repeatMonthsByWeek.indexOf('JUL') !== -1} onValueChange={(v) => setMonthsByWeek('JUL', v)} />
              <Inputs.Checkbox variant={variant} label='August' checked={repeatMonthsByWeek.indexOf('AUG') !== -1} onValueChange={(v) => setMonthsByWeek('AUG', v)} />
              <Inputs.Checkbox variant={variant} label='September' checked={repeatMonthsByWeek.indexOf('SEP') !== -1} onValueChange={(v) => setMonthsByWeek('SEP', v)} />
              <Inputs.Checkbox variant={variant} label='October' checked={repeatMonthsByWeek.indexOf('OCT') !== -1} onValueChange={(v) => setMonthsByWeek('OCT', v)} />
              <Inputs.Checkbox variant={variant} label='November' checked={repeatMonthsByWeek.indexOf('NOV') !== -1} onValueChange={(v) => setMonthsByWeek('NOV', v)} />
              <Inputs.Checkbox variant={variant} label='December' checked={repeatMonthsByWeek.indexOf('DEC') !== -1} onValueChange={(v) => setMonthsByWeek('DEC', v)} />
            </Form.Group>
            <Form.Group>On:</Form.Group>
            <Form.Group className='ml-4'>
              <Inputs.Checkbox variant={variant} label='Monday' checked={repeatDaysMonthlyByWeek.indexOf('MON') !== -1} onValueChange={(v) => setWeekDaysForMonthlyByWeek('MON', v)} />
              <Inputs.Checkbox variant={variant} label='Tuesday' checked={repeatDaysMonthlyByWeek.indexOf('TUE') !== -1} onValueChange={(v) => setWeekDaysForMonthlyByWeek('TUE', v)} />
              <Inputs.Checkbox variant={variant} label='Wednesday' checked={repeatDaysMonthlyByWeek.indexOf('WED') !== -1} onValueChange={(v) => setWeekDaysForMonthlyByWeek('WED', v)} />
              <Inputs.Checkbox variant={variant} label='Thursday' checked={repeatDaysMonthlyByWeek.indexOf('THU') !== -1} onValueChange={(v) => setWeekDaysForMonthlyByWeek('THU', v)} />
              <Inputs.Checkbox variant={variant} label='Friday' checked={repeatDaysMonthlyByWeek.indexOf('FRI') !== -1} onValueChange={(v) => setWeekDaysForMonthlyByWeek('FRI', v)} />
              <Inputs.Checkbox variant={variant} label='Saturday' checked={repeatDaysMonthlyByWeek.indexOf('SAT') !== -1} onValueChange={(v) => setWeekDaysForMonthlyByWeek('SAT', v)} />
              <Inputs.Checkbox variant={variant} label='Sunday' checked={repeatDaysMonthlyByWeek.indexOf('SUN') !== -1} onValueChange={(v) => setWeekDaysForMonthlyByWeek('SUN', v)} />
            </Form.Group>
          </Tab>
        </Tabs>
      </Form.Group>
    </>
  );
}
